import {
  Box,
  Button,
  Grid,
  InputAdornment,
  InputBase,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import AppBar from "@mui/material/AppBar";
import Cookies from "js-cookie";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import axiosInstance from "../AxiosBaseApi";
import FooterNav from "./FooterNav";
//   import axiosInstance from "../../AxiosBaseApi";

const Withdrawal = () => {
  const history = useNavigate();
  const [loginStatus, setLoginStatus] = useState(false);
  const [selectedTab, setSelectedTab] = useState("Main");
  const [data, SetData] = useState("");
  const [bankData, SetBankData] = useState([]);
  const [userInfo, setUserInfo] = useState({
    user: {},
    totalRecharge: 0,
    totalWithdraw: 0,
  });
  const [amount, setAmount] = useState(); // default value
  const [passward, setPassward] = useState(); // default value
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const checkTime = () => {
      const now = new Date();
      const hours = now.getHours();
      const day = now.getDay(); // 0 = Sunday, 1 = Monday, ..., 6 = Saturday
      // Monday to Friday & between 6 AM - 7 PM
      if (day >= 1 && day <= 5 && hours >= 9 && hours < 18) {
        setShowButton(true);
      } else {
        setShowButton(false);
      }
    };

    checkTime(); // Initial check
    const interval = setInterval(checkTime, 60000); // Check every minute

    return () => clearInterval(interval); // Cleanup interval
  }, []);

  
  const quickAmounts = [300, 1200, 3000, 10000, 18000, 50000, 100000]; // quick money options

  const handleManualUPIPaymentRequest = async (amount) => {
    window.location.href = `/wallet/paynow/manual_upi?am=${amount}`;
  };




  const getBankData = async (uid) => {
    try {
      const response = await axiosInstance
        .get(`/bet.php?action=bankcard&user=${uid}`)

        .then((res) => {
          if (res.status === 200) {
            SetBankData(res.data);
            // setLoading(false);
          } else {
            alert(res.data.message);
          }
        });
    } catch (error) {
      console.log("Error", error);
    }
  };

  // useEffect(() => {
  //   const token = localStorage.getItem("mamberId");
  //   if (!token) {
  //     navigate("/login");
  //   } else {
  //     getUserData(token);
  //   }
  // }, []);


  const handleSubmit = async (event) => {
    const id = localStorage.getItem("mamberId");
    event.preventDefault();
    if(selectedTab ==="Personal"){
      if (data[0]?.pmain >= amount) {
        try {
          // Awaiting the axios request and directly getting the response
          const response = await axiosInstance.post(
            `/bet.php?action=pwithdrawal&user=${id}&amount=${amount}&upi=&pass=${passward}`
          );
  
          // Handling the response
          if (response.status === 200) {
            history("/withdrawal");
            alert(response.data[0].status);
          } else {
            alert(response.data[0].status);
          }
        } catch (error) {
          console.log("Error", error);
        }
      } else {
        alert("Insufficient funds");
      }

    }else{
    if (data[0]?.balance >= amount) {
      try {
        // Awaiting the axios request and directly getting the response
        const response = await axiosInstance.post(
          `/bet.php?action=withdrawal&user=${id}&amount=${amount}&upi=&pass=${passward}`
        );

        // Handling the response
        if (response.status === 200) {
          history("/withdrawal");
          alert(response.data[0].status);
        } else {
          alert(response.data[0].status);
        }
      } catch (error) {
        console.log("Error", error);
      }
    } else {
      alert("Insufficient funds");
    }
  }
  };

  const handleAmountClick = (value) => {
    setAmount(value);
  };

  const handleInputChangePassword=(e) =>{
    setPassward(e.target.value)
  }
  const handleInputChange = (e) => {
    setAmount(e.target.value);
  };
  const getUserData = async (uid) => {
    try {
      const response = await axiosInstance
        .get(`/bet.php?action=getuserinfo&user=${uid}`)

        .then((res) => {
          if (res.status === 200) {
            SetData(res.data);
          } else {
            alert(res.data.message);
          }
        });
    } catch (error) {
      console.log("Error", error);
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("mamberId");
    if (!token) {
      history("/login");
    } else {
      getUserData(token);
      getBankData(token)
    }
  }, []);

  const handleTabClick = (tabId) => {
    setSelectedTab(tabId);
  };

  return (
    <>
      <div style={{ width: "100%", marginBottom: "40px" }}>
        <Box sx={{ marginBottom: "5px" }}>
          <AppBar
            position="static"
            style={{
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "2px 10px",
              height: "3.22667rem",
              boxShadow: "unset",
              background: "#3d3b6f",
            }}
          >
            <Box onClick={() => history(-1)} style={{ textDecoration: "none" }}>
              <ChevronLeftIcon
                fontSize="medium"
                style={{
                  // width: "60px",
                  color: "#fff",
                  border: "1px solid #f2f3f5",
                  borderRadius: 50,
                }}
              />
            </Box>
            <Typography
              style={{ color: "#fff", fontSize: "24px", marginLeft: 50 }}
            >
              Withdrawal
            </Typography>

            <Box style={{ display: "flex" }}>
              <Link to="/financialrecords" style={{ textDecoration: "none" }}>
                <Typography
                  style={{
                    borderColor: "#fff",
                    color: "#fff",
                    fontSize: "12px",
                  }}
                >
                  Withdrawal History
                </Typography>
              </Link>
            </Box>
          </AppBar>
        </Box>

        {/*Slider   */}
        <Grid
          container
          direction="column"
          sx={{ maxHeight: { xs: 190, sm: 250, md: 270, lg: 340 } }}
          alignItems="center"
          justifyContent="center"
        >
          <Grid
            style={{
              width: "95%",
              marginTop: "5px",
              background: "#fff",
              borderRadius: "15px",
              minHeight: "120px",
              backgroundSize: "contain", // Makes sure the image scales without being distorted
              backgroundRepeat: "no-repeat", // Prevents image repetition
              backgroundPosition: "center",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              padding: 20,
            }}
          >
            <Box style={{ display: "flex", gap: 6, alignItems: "center" }}>
              <img
                // width="100%"
                height="20px"
                style={{ borderRadius: "10px" }}
                src="./images/balance.png"
              />
              <Typography style={{ fontSize: "16px", color: "#333" }}>
               {selectedTab} Balance
              </Typography>
            </Box>
            {selectedTab ==="Main"
             ?
              
            <Box style={{ display: "flex", gap: 6, alignItems: "center" }}>
              <Typography style={{ fontSize: "32px", color: "#333" }}>
                ₹{data[0]?.balance}
              </Typography>
              <img width={20} height={15} src="./images/load.png" />
            </Box>
:

<Box style={{ display: "flex", gap: 6, alignItems: "center" }}>
<Typography style={{ fontSize: "32px", color: "#333" }}>
  ₹{data[0]?.pmain}
</Typography>
<img width={20} height={15} src="./images/load.png" />
</Box>
 }
          </Grid>
        </Grid>

        <div style={{ display: "flex", margin: "10px" }}>
          <div
            role="tablist"
            style={{
              width: "100%",
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {[
              {
                id: "Main",
                name: "Main wallet",
                imgSrc: "./images/wall.png",
              },
              {
                id: "Personal",
                name: "Personal wallet",
                imgSrc: "./images/wallt.png",
              },
            ].map((tab) => (
              <div
                key={tab.id}
                role="tab"
                tabIndex="0"
                aria-selected={selectedTab === tab.id}
                onClick={() => handleTabClick(tab.id)}
              >
                <div
                  style={{
                    minWidth: "7rem",
                    // height: "6rem",
                    padding: "2px",
                    margin: 2,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                    backgroundSize: "100% 100%",
                    marginBottom: "1.17333rem",
                    borderRadius: 10,
                    backgroundColor:
                      selectedTab === tab.id ? "#aea0a0" : "#fff", // Apply green color if active
                    backgroundImage:
                      selectedTab === tab.id
                        ? "url(https://91club.bet/assets/png/bgActive-805fae0e.png)" // No background image if active
                        : "none", // Keep image for inactive
                  }}
                >
                  {/* <div
                      style={{
                        width: "50px",
                        height: "50px",
                        backgroundSize: "100% 100%",
                        backgroundImage: `url(${tab.imgSrc})`,
                      }}
                    /> */}
                  <Typography
                    style={{
                      fontSize: "14px",
                      color: selectedTab === tab.id ? "#fff" : "#000",
                    }}
                  >
                    {tab.name}
                  </Typography>
                </div>
              </div>
            ))}
          </div>
        </div>

        <Box style={{ padding: "0 20px" }} borderRadius={2}>
          {bankData.length>=1?
          <> <NavLink style={{ textDecoration: "none" }} to={`/addbankcard`}>
          <Button
            variant="contained"
            fullWidth
            sx={{
              padding: "0 20px",
              minHeight: 100,
              backgroundColor: "#fff",
              display: "block",
              "&:hover": {
                background: "#fff", // Keep the same gradient on hover
              },
            }}
          >
           <Typography variant="body1" style={{border:"1px solid",width:'50px',}}>Edit</Typography>

            <Typography variant="body1">Account:{bankData[0]?.account}</Typography>
            <Typography variant="body1">IFSC:{bankData[0]?.ifsc}</Typography>

          </Button>
        </NavLink></>
        :
          <NavLink style={{ textDecoration: "none" }} to={`/addbankcard`}>
            <Button
              variant="contained"
              fullWidth
              sx={{
                padding: "0 20px",
                minHeight: 100,
                backgroundColor: "#fff",
                display: "block",
                "&:hover": {
                  background: "#fff", // Keep the same gradient on hover
                },
              }}
            >
              <img
                height="30px"
                style={{ borderRadius: "10px" }}
                src="./images/walladd.png"
              />
              <Typography variant="body1">Add a bank account number</Typography>
            </Button>
          </NavLink>
        }
          {/* </Box> */}

          <Typography
            style={{ fontSize: "14px", padding: "5px 16px", color: "#fff" }}
          >
            Need to add beneficiary information to be able to withdraw money
          </Typography>
        </Box>

        <div style={{ display: "none", margin: "10px" }}>
          <div
            role="tablist"
            style={{ display: "flex", flexWrap: "wrap", alignItems: "center" }}
          >
            {[
              {
                id: "lottery",
                name: "Innate UPI-QR",
                imgSrc: "./images/wall.png",
              },
              {
                id: "flash",
                name: "Expert PAytm-QR",
                imgSrc: "./images/wallt.png",
              },
            ].map((tab) => (
              <div
                key={tab.id}
                role="tab"
                tabIndex="0"
                aria-selected={selectedTab === tab.id}
                onClick={() => handleTabClick(tab.id)}
              >
                <div
                  style={{
                    minWidth: "7rem",
                    height: "6rem",
                    padding: "2px",
                    margin: 5,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                    backgroundSize: "100% 100%",
                    marginBottom: "1.17333rem",
                    borderRadius: 10,
                    backgroundColor:
                      selectedTab === tab.id ? "#aea0a0" : "#fff", // Apply green color if active
                    backgroundImage:
                      selectedTab === tab.id
                        ? "url(https://91club.bet/assets/png/bgActive-805fae0e.png)" // No background image if active
                        : "none", // Keep image for inactive
                  }}
                >
                  <div
                    style={{
                      width: "50px",
                      height: "50px",
                      backgroundSize: "100% 100%",
                      backgroundImage: `url(${tab.imgSrc})`,
                    }}
                  />
                  <Typography
                    style={{
                      fontSize: "14px",
                      color: selectedTab === tab.id ? "#fff" : "#000",
                    }}
                  >
                    {tab.name}
                  </Typography>
                </div>
              </div>
            ))}
          </div>
        </div>

        <Box mt={2} p={2}>
          <Grid
            container
            spacing={1}
            justifyContent="space-between"
            wrap="wrap"
          >
            {quickAmounts.map((value) => (
              <Grid item key={value}>
                <Button
                  variant="contained"
                  // color={amount === value ? 'primary' : 'default'}
                  onClick={() => handleAmountClick(value)}
                  sx={{
                    padding: "10px 20px",
                    minWidth: "6rem",
                    backgroundColor: amount === value ? "#fc6c6c" : "#e0e0e0",
                  }}
                >
                  <Typography variant="body1">
                    {value}
                    {/* {value >= 1000 ? `${value / 1000}K` : value} */}
                  </Typography>
                </Button>
              </Grid>
            ))}
          </Grid>
{showButton === true ?

          <Box
            component="form"
            onSubmit={handleSubmit}
            sx={{
              backgroundColor: "#fff",
              marginTop: 2,
              padding: 2,
              borderRadius: 2,
            }}
          >
            <Box display="flex" alignItems="center" flexDirection="column" gap={1}>
              <InputBase
                value={amount}
                disabled
                onChange={handleInputChange}
                placeholder="Please enter the amount"
                inputProps={{ type: "tel", inputMode: "numeric" }}
                startAdornment={
                  <InputAdornment
                    position="start"
                    size="large"
                    style={{ color: "#8636dada" }}
                  >
                    ₹
                  </InputAdornment>
                }
                sx={{
                  flex: 1,
                  backgroundColor: "#E1E1E1",
                  padding: "5px 10px",
                  borderRadius: "24px",
                  color: "#8636dada",
                  width:'100%'
                }}
              />
               <InputBase
               type="password"
               required
                value={passward}
                onChange={handleInputChangePassword}
                placeholder="Please enter the payment password"
                inputProps={{ type: "tel", inputMode: "numeric" }}
                startAdornment={
                  <InputAdornment
                    position="start"
                    size="large"
                  >
                   
                  </InputAdornment>
                }
                sx={{
                  flex: 1,
                  backgroundColor: "#E1E1E1",
                  padding: "5px 10px",
                  borderRadius: "24px",
                  // color: "#8636dada",
                   width:'100%'
                }}
              />
            </Box>

            <Box mt={2} textAlign="center">
              <Button
                type="submit"
                variant="contained"
                fullWidth
                size="large"
                sx={{
                  color: "#fff",
                  borderRadius: "20px",
                  padding: "5px 40px",
                  background: "#3d3b6f",
                  "&:hover": {
                    background: "#3d3b6f",
                    color: "#fff", // Ensure the text color remains white on hover
                  },
                }}
              >
                Withdrawal
              </Button>
              {/* </NavLink> */}
            </Box>
          </Box>:<></>
          }
        </Box>

        <Box sx={{ backgroundColor: "#fff", padding: 2, borderRadius: 2 }}>

          <Box
            mt={2}
            p={2}
            sx={{ backgroundColor: "#f9f9f9", borderRadius: "8px" }}
          >
            <Typography style={{ fontSize: "13px" }} color="#768096">
              * Grade P regular employees daily withdrawal time: 9 am to 6 pm
            </Typography>
            <Typography style={{ fontSize: "13px" }} color="#768096">
              * Grade P regular employees do not have to pay any taxes every
              time they withdraw cash from their personal wallets.
            </Typography>
            <Typography style={{ fontSize: "13px" }} color="#768096">
              * Grade P regular employees are required to pay a 10% tax every
              time they withdraw cash from your income wallet.
            </Typography>
            <Typography style={{ fontSize: "13px" }} color="#768096">
              * This tax is levied according to the tax policy of the India
              government
            </Typography>
            {/* <Typography style={{ fontSize: "13px" }} mt={2} color="#768096">
                  * Please confirm your beneficial account information before
                  withdrawing. If your information is incorrect, our company will
                  not be liable for the amount of loss.
                </Typography> */}
            <Typography style={{ fontSize: "13px" }} color="#768096">
              * The bank will complete the transfer for you within 0-72hours,
              please wait patiently.
            </Typography>
          </Box>
          {/* </Box> */}
        </Box>
      </div>
      <FooterNav />
    </>
  );
};

export default Withdrawal;
